
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketingPages/[marketingPage]",
      function () {
        return require("private-next-pages/marketingPages/[marketingPage]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketingPages/[marketingPage]"])
      });
    }
  